/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { db } from "../config/firebaseConfig";
import CopyComponent from "./utils/CopyComponent";
import FirestoreTimestampToDate from "./utils/FirebaseTimetoDate";

const EtherScan=() => {
  const [id, setId]=useState(localStorage.getItem("roomId")||"");
  const [transactions, setTransactions]=useState([]);
  const [blocks, setBlocks]=useState([]);
  const [activeTab, setActiveTab]=useState("blocks"); // "blocks" or "transactions"

  useEffect(() => {
    const fetchTransactions=async () => {
      const transactionsCollection=db
        .collection("rooms")
        .doc(id)
        .collection("transactions");
      const snapshot=await transactionsCollection.get();
      const transactionsData=snapshot.docs.map((doc) => ({
        ...doc.data(),
        timestamp: FirestoreTimestampToDate(doc.data().timestamp),
        validate: doc.data().validatedAt
          ? FirestoreTimestampToDate(doc.data().timestamp)
          :"Not Validated",
        id: doc.id,
        rawTimestamp: doc.data().timestamp.toString(),
      }));
      setTransactions(transactionsData);
    };

    fetchTransactions();
  }, [id]);

  useEffect(() => {
    const fetchBlocks=async () => {
      const blocksCollection=db
        .collection("rooms")
        .doc(id)
        .collection("blocks");
      const snapshot=await blocksCollection.get();
      const blocksData=snapshot.docs.map((doc) => ({
        ...doc.data(),
        timestamp: FirestoreTimestampToDate(doc.data().created_at),
        id: doc.id,
        rawTimestamp: doc.data().timestamp?.toString()||"",
      }));
      setBlocks(blocksData);
    };

    fetchBlocks();
  }, [id]);

  return (
    <section className="min-h-screen pt-10 pb-8 px-6">
      <div className=" max-w-[83vw] mx-auto text-white">
        <h1 className="text-2xl font-bold text-white mb-6">Explore Network</h1>

        {/* Tabs */}
        <div className="flex gap-4 mb-6">
          <button
            onClick={() => setActiveTab("blocks")}
            className={`px-6 py-3 rounded-lg font-semibold transition-all ${activeTab==="blocks"
              ? "bg-gradient-to-r from-[#6C4FFF] to-[#5B3FE8] text-white"
              :"bg-[#343B4F]/60 text-white/60 hover:text-white"
              }`}
          >
            Blocks
          </button>
          <button
            onClick={() => setActiveTab("transactions")}
            className={`px-6 py-3 rounded-lg font-semibold transition-all ${activeTab==="transactions"
              ? "bg-gradient-to-r from-[#6C4FFF] to-[#5B3FE8] text-white"
              :"bg-[#343B4F]/60 text-white/60 hover:text-white"
              }`}
          >
            Transactions
          </button>
        </div>

        {/* Blocks Table */}
        {activeTab==="blocks"&&(
          <div className="bg-[#343B4F]/60 backdrop-blur rounded-xl p-8 border border-white/10 overflow-x-auto ">
            <h2 className="text-xl font-bold text-white mb-6">Blocks</h2>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-white/10">
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Sr.No.
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Hash
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Nonce
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Previous Block Hash
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Transaction Hash
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Timestamp
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {blocks&&blocks.length>0? (
                    blocks.map((block, index) => (
                      <tr
                        key={index}
                        className="border-b border-white/5 hover:bg-white/5"
                      >
                        <td className="py-4 px-4 text-white text-sm">
                          {index+1}
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          <CopyComponent data={block.hash} />
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          {block.nonce||"-"}
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          {block.previousBlockHash? (
                            <CopyComponent data={block.previousBlockHash} />
                          ):(
                            <span className="text-purple-400">
                              Genesis Block
                            </span>
                          )}
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          {block.transactions&&
                            block.transactions.length>0? (
                            <div className="flex flex-col gap-1">
                              {block.transactions.map((BT, txIndex) => (
                                <div
                                  key={txIndex}
                                  className="flex items-center gap-2"
                                >
                                  <span className="text-white/60">
                                    {txIndex+1}.
                                  </span>
                                  <CopyComponent data={BT.hash} />
                                </div>
                              ))}
                            </div>
                          ):(
                            <span className="text-white/60">-</span>
                          )}
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          {block.timestamp}
                        </td>
                      </tr>
                    ))
                  ):(
                    <tr>
                      <td
                        colSpan="6"
                        className="py-8 text-center text-white/60"
                      >
                        No Blocks Available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Transactions Table */}
        {activeTab==="transactions"&&(
          <div className="bg-[#343B4F]/60 backdrop-blur rounded-xl p-8 border border-white/10 overflow-x-auto ">
            <h2 className="text-xl font-bold text-white mb-6">Transactions</h2>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-white/10">
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      ID
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Hash
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Sender
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Receiver
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Amount
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Timestamp
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Status
                    </th>
                    <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                      Validated On
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {transactions&&transactions.length>0? (
                    transactions.map((transaction, index) => (
                      <tr
                        key={index}
                        className="border-b border-white/5 hover:bg-white/5"
                      >
                        <td className="py-4 px-4 text-white text-sm">
                          <CopyComponent data={transaction.id} />
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          <CopyComponent data={transaction.hash} />
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          <CopyComponent data={transaction.sender} />
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          <CopyComponent data={transaction.receiver} />
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          {transaction.amount}
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          {transaction.timestamp}
                        </td>
                        <td className="py-4 px-4">
                          <span
                            className={`px-3 py-1 rounded-full text-xs font-semibold ${transaction.status==="Verified"
                              ? "bg-green-500/20 text-green-400"
                              :"bg-yellow-500/20 text-yellow-400"
                              }`}
                          >
                            {transaction.status}
                          </span>
                        </td>
                        <td className="py-4 px-4 text-white text-sm">
                          {transaction.validate}
                        </td>
                      </tr>
                    ))
                  ):(
                    <tr>
                      <td
                        colSpan="8"
                        className="py-8 text-center text-white/60"
                      >
                        No Transactions Available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default EtherScan;
